import { Component, OnDestroy, OnInit } from '@angular/core';
import {Observable} from 'rxjs';
import {SubscriptionList} from '../../../shared/models/asp.types';
import {ServiceAppointmentState} from '../../../store/service-appointment/service-appointment.reducer';
import {debounceTime} from 'rxjs/operators';
import {
  selectAppointmentFormAndLookUpData, selectAppointmentFormDetailMap,
  selectVehicleFormImageUrl,
  selectVehicleFormMakeModelYearText
} from '../../../store/service-appointment/service-appointment.selectors';
import {Store} from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { unsubscribeSubscriptions } from '../../../shared/services/util.service';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent implements OnInit, OnDestroy {

  view = 'summary';
  imageUrl$: Observable<string>;
  makeModelYear$: Observable<string>;
  detailMap$: Observable<{ [key: string]: string }>;
  private subs: SubscriptionList = {};

  constructor(    private readonly serviceAppointmentState: Store<ServiceAppointmentState>,
    private readonly translate: TranslateService) { }

  ngOnInit(): void {
    this.imageUrl$ = this.serviceAppointmentState.select(selectVehicleFormImageUrl);
    this.makeModelYear$ = this.serviceAppointmentState.select(selectVehicleFormMakeModelYearText);
    this.subs.detailMapSub = this.serviceAppointmentState.select(selectAppointmentFormAndLookUpData)
                        .pipe(debounceTime(300))
                        .subscribe(d => this.detailMap$ = this.serviceAppointmentState.select(selectAppointmentFormDetailMap));
  }

  ngOnDestroy(): void {
    unsubscribeSubscriptions(this.subs);
  }

}
